import { useSiteStore } from '~/stores/site.store';
import type { ISitemapRemap } from '~/interfaces/dto/sitemap/response';
import { appleAppIds } from 'assets/data/config';

export default function useGetPage(
  {
    path,
    setSeoMeta,
  }: {
    path?: string;
    setSeoMeta?: boolean;
  } = { setSeoMeta: true },
) {
  const route = useRoute();
  const settings = useSiteStore();
  const localeStore = useLocaleStore();
  const { getAbsoluteUrl } = useAbsoluteUrl();

  const getPath = (path: string = ''): Partial<ISitemapRemap> => {
    if (path === 'undefined') path = '';
    return (
      settings.getSitemapMap.get(`/${path}`) ||
      settings.getSitemapMap.get(`/${path}/`)
    );
  };
  const page = ref<Partial<ISitemapRemap>>({});

  watchEffect(() => {
    const pageValue =
      route.params.contentType !== 'home'
        ? getPath(path || String(route.params.contentType))
        : getPath();
    page.value = pageValue ?? getPath();

    if (setSeoMeta) {
      useSeoMeta({
        applicationName: 'JPC',
        ...page.value?.nuxtSeoParams,
      });
      useHead({
        meta: [
          {
            name: 'Jackpot City',
            content: `app-id=${appleAppIds[settings.getRegionCode]}, app-argument=${document?.location?.host}`,
          },
        ],
        link: [
          {
            rel: 'canonical',
            href: getAbsoluteUrl(route.path),
          },
        ],
        htmlAttrs: {
          lang: localeStore.getLocale,
        },
      });
    }
  });

  return page;
}
